import React from "react";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import OutlinedInput from "@mui/material/OutlinedInput";
import Select from "@mui/material/Select";
import {
  PlayTestMetadataValueTypeLabels,
  PlayTestMetadataValueTypeDescriptions,
} from "@seabrookstudios/pitch2table-core";
import CircularProgress from "@mui/material/CircularProgress";

const Label = "Value Type";

/**
 * Value types currently supported end-to-end in the web UI.
 * @type {import("@seabrookstudios/pitch2table-core").PlayTestMetadataValueType[]}
 */
const SupportedValueTypes = ["NUMERIC", "BOOLEAN"];

/**
 * @param {object} props
 * @param {import("@seabrookstudios/pitch2table-core").PlayTestMetadataValueType} props.value
 * @param {(value: import("@seabrookstudios/pitch2table-core").PlayTestMetadataValueType) => void} props.onChange
 * @param {boolean} [props.isPending]
 * @param {string} props.helperText
 * @param {boolean} [props.disabled]
 */
export const MetadataValueTypeSelect = ({
  value,
  onChange,
  helperText,
  disabled = false,
  isPending = false,
}) => {
  /**
   * @param {*} ev
   */
  const onChangeHandler = (ev) => {
    onChange(ev.target.value);
  };

  return (
    <FormControl sx={{ width: "100%" }} margin="normal" disabled={disabled}>
      <InputLabel id="play-test-metadata-value-type-label">{Label}</InputLabel>
      <Select
        labelId="play-test-metadata-value-type-label"
        id="play-test-metadata-value-type"
        value={value}
        onChange={onChangeHandler}
        placeholder={Label}
        label={Label}
        input={<OutlinedInput label={Label} />}
      >
        {isPending ? (
          <CircularProgress />
        ) : (
          SupportedValueTypes.map((type) => (
            <MenuItem key={type} value={type}>
              {PlayTestMetadataValueTypeLabels[type]} - {PlayTestMetadataValueTypeDescriptions[type]}
            </MenuItem>
          ))
        )}
      </Select>
      <FormHelperText>{helperText}</FormHelperText>
    </FormControl>
  );
};
